import React from "react";
import MemberCard from "../components/MemberCard";
import SectionHeading from "../components/SectionHeading";

/**
 * Members page
 * Props:
 *  - content: siteContent.members
 */
function Members({ content }) {
  return (
    <>
      <section className="hero-section py-5">
        <div className="container text-center">
          <h1 className="fw-bold display-6 mb-2">{content.title}</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{content.subtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Meet the team" title="Our Committee Members" />
          <div className="row g-4">
            {content.list.map((member) => (
              <div className="col-md-6 col-lg-4" key={member.id}>
                <MemberCard member={member} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Members;
